import { Loader2 } from 'lucide-react';
import { cn } from '@/shared/utils/utils';

const SIZE_CLASSES = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-7 w-7',
} as const;

export function Spinner({ className, size = 'md' }: { className?: string; size?: keyof typeof SIZE_CLASSES }) {
  return <Loader2 className={cn(SIZE_CLASSES[size], 'animate-spin text-primary', className)} aria-label="Loading" />;
}
